<template>
  <div>
    <el-dialog :title="title" :visible="visible" width="80%" @close="onClose">
      <el-form :model="form" size="mini"  ref="form" label-width="120px">
          <div v-if="taxM">
        <el-form-item label="企业名称：">
          <el-input v-model="taxM.name" disabled></el-input>
        </el-form-item>
          <el-form-item label="税号：">
              <el-input v-model="taxM.tax_id" disabled></el-input>
          </el-form-item>
          <el-form-item label="手机号：">
              <el-input v-model="taxM.mobile" disabled></el-input>
          </el-form-item>
          <el-form-item label="邮箱：">
              <el-input v-model="taxM.email" disabled></el-input>
          </el-form-item>
              <el-form-item required label="备注：">
                  <el-input v-model="taxM.remark" placeholder="请输入备注" disabled></el-input>
              </el-form-item>
          </div>
                <el-row>
                  <el-col>
                      <el-upload
                        class="upload-demo"
                        drag
                        action="#"
                        :before-upload="handleBeforeUpload"
                        :on-success="uploadSuccess"
                        :auto-upload="false"
                        :on-change="uploadFile"
                        :file-list="fileList"
                        list-type="picture"
                        multiple
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                      </el-upload>
                  </el-col>
                </el-row>
          <el-row>
          <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
            <el-button size="mini" @click="closeUpload">取消</el-button>
            <el-button  size="mini" type="primary" @click="ok">确定</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import CryptoJS from "crypto-js";
  import moment from "moment";
  import axios from "axios";
  export default {
    name:'eInvoiceDayBillForm',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    }
    ,
    data(){
      return {
        taxM:null,
        form:{
          id:'',
          lgsshop_name:'',
           lgs_shop_id:'',
            file_url:'',
            upload_id:'',
            file_name:''
        },
        defaultProps: {
          children: 'children',
          label: 'name',
        },
        docCateList:[
        ],
        isShow:false,
        index:'',
        curShop:'',
        id:'',
        name:'',
        url:'',
        keywords:'',
        fileList:[],
        mList:[],
        pageNum:1,
        pageSize:10,
        total:0,
        item:{}
      }
    },
    mounted() {
      console.log('--------','')
      this.DataList();
      this.getUploadCategoryTree();
    },
    methods:{
      goSearch(){
        this.pageNum = 1;
        this.DataList()
      },
      append(){

      },
      closeUpload(){
        this.isShow=false;
      },
        getShopInvoiceDefaultOne(){
            let _this=this;
            let params={
                access_token:sessionStorage.getItem('token'),
                company_id:sessionStorage.getItem('company_id'),
                shop_id:this.form.lgs_shop_id,
            };
            this.$axios.findShopInvoiceDefaultOne(params).then((res)=>{
                if(res.code==200){
                    _this.taxM=res.data;
                }
                console.log(res);
            });
        },
      getUploadCategoryTree(){
        let _this=this;
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        this.$axios.findUploadCategoryTree(params).then((res)=>{
          if(res.code==200){
           _this.docCateList=res.data;
          }
          console.log(res);
        });
      },
      goUpload(){
            let _this=this;
            let params={
              access_token:sessionStorage.getItem('token'),
              company_id:sessionStorage.getItem('company_id'),
              name:_this.formData.name,
              foreign_id:_this.formData.foreign_id,
              contract_id: _this.formData.contract_id,
              source: _this.formData.source,
              upload_id:_this.formData.upload_id
            };
            console.log('uploadForeignSave params------',params)
            this.$axios.uploadForeignSave(params).then((res)=>{
              if(res.code==200){
                this.$message({
                  message:'添加成功！',
                  type:'success',
                  offset:225,
                  duration:4000,
                  onClose:()=>{
                   // this.$router.push('/preApprovalList')
                  }
                });
                _this.isShow=false;
                _this.pageNum=1;
                _this.DataList();
              }
              console.log(res);
            });
      },
      uploadDoc(){
        this.isShow=true;
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      onClose(){
        this.$emit('update:visible',false)
        this.closeForm();
      },
      close(){
        this.$emit('update:visible',false)
        this.closeForm();
      },
      ok(){
          let params={
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
              file_url:this.form.file_url,
              id:this.form.id
          }
          this.$axios.dayBillOilupdateInvoice(params).then(res=>{
              if(res.code==200){
                  this.$emit('eventChoose',this.id,this.name,this.url);
                  this.closeForm();
              }
          })

      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          source:this.formData.source,
          foreign_id:this.formData.foreign_id,
          contract_id:this.formData.contract_id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        if(this.keywords){
          param.keywords=this.keywords;
        }
        console.log('eDocList--------',param)
        this.$axios.findUploadListP(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row,index){
        this.index=index;
        this.id=row.id;
        this.name=row.name;
        this.url=row.url;
        // this.formData.name=row.name;
        // this.formData.id=row.id;
        // this.formData.url=row.url;
        this.item=this.mList[index];
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      async uploadFile (item) {
        let _this=this;
       // let formData = new FormData()
        let file = item.raw;
        this.logoFile=item.raw;

        let file_md5, file_sha1;
        await this.calculateMD5(file).then(md5 => {
          file_md5 = md5;
          console.log('MD5:', md5)
        });
        await this.calculateSHA1(file).then(sha1 => {
          file_sha1 = sha1;
          console.log('SHA1:', sha1);
        });

        // 获取文件名
        const fileName = file.name;
        // 获取文件大小
        const fileSize = file.size;
        // 获取文件后缀
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
        console.log('文件名称：', fileName);
        console.log('文件后缀：', fileExtension);
        console.log('文件大小：', fileSize);
        let param_1 = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          md5: file_md5,
          sha1: file_sha1,
          size: fileSize
        };
        this.$axios.uploadOne(param_1).then(res => {
          if (res.code == 200&&res.data.length>0) {

            //文件已经存在
            _this.form.file_url = res.data.url;
            _this.form.upload_id=res.data.id;

            var img = {
              name: res.data.name,
              url: res.data.url
            }
            _this.fileList.push(img);

          } else {

           //保存到阿里云
            let param = {
              access_token: sessionStorage.getItem('token'),
              company_id: sessionStorage.getItem('company_id'),
            };
            // console.log(file);
            this.$axios.getAliJsonCmp(param).then(res => {
              console.log('ali_json------', res)
              let data = res['data'];
              console.log(data);
              let suffix = _this.get_suffix(file.name);
              let autoname = _this.Ymdhis();
              let key = data['dir'];
              let host = data['host'];

              let path = data['path'] != null && data['path'] != undefined ? data['path'] : '';
              let request = new FormData();
              request.append('name', file.name);
              request.append("key", key + path + autoname + suffix);//文件名字，可设置路径
              request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
              request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
              request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
              request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
              request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
              request.append('file', file);//需要上传的文件 file
              console.log('request=------', request)
              _this.uploadAliOss(host,request).then(url=>{
                var fileurl = url; //上传完成后的文件oss地址
                var fullurl = host + '/' + fileurl;
                  _this.form.file_url=fullurl;
                  _this.form.file_name=file.name;
                  var img={
                    name:_this.form.file_name,
                    url:_this.form.file_url
                  }
                  _this.fileList.push(img);
                //更新上传资料
                let upload_params = {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  name: fileName,
                  size: fileSize,
                  ext: fileExtension,
                  md5: file_md5,
                  sha1: file_sha1,
                  path: fileurl,
                  url: fullurl,
                  status: 1,
                };
                console.log('upload---save params', upload_params)
                _this.$axios.uploadSave(upload_params).then(resu => {
                  _this.formData.upload_id=resu.data.id;
                  console.log('upload---save', resu)
                });
              });

            });

            //保存到本地
            // formData.append('file', file);
            // formData.append('csn','chy');
            // this.$axios.ossLocalUploadFile(formData).then(res => {
            //   //请求成功，触发then中的函数
            //   console.log('lu------888---upload -res--------',res)
            //   var fullurl=res.data;
            //   var fileurl=res.path;
            //   _this.formData.file_url=fullurl;
            //   _this.formData.name=file.name;
            //   var img={
            //     name:_this.formData.name,
            //     url:_this.formData.file_url
            //   }
            //   _this.fileList.push(img);
            //  //更新上传资料
            //   let upload_params = {
            //     access_token: sessionStorage.getItem('token'),
            //     company_id: sessionStorage.getItem('company_id'),
            //     name: fileName,
            //     size: fileSize,
            //     ext: fileExtension,
            //     md5: file_md5,
            //     sha1: file_sha1,
            //     path: fileurl,
            //     url: fullurl,
            //     status: 1,
            //   };
            //   console.log('upload---save params', upload_params)
            //   _this.$axios.uploadSave(upload_params).then(resu => {
            //     _this.formData.upload_id=resu.data.id;
            //     console.log('upload---save', resu)
            //   }).catch(error=>{
            //     console.log('upload---error', error)
            //   });
            //
            //
            // })
            //   .catch(error =>
            //     //请求失败，触发catch中的函数 可省略
            //     console.log(error)
            //   )

          }
        });
      },
      async readFileAsBinaryString(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          reader.readAsBinaryString(file);
        });
      },
      async  calculateMD5(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.MD5(words).toString();
        });
      },
      async calculateSHA1(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.SHA1(words).toString();
        });
      },
      async uploadAliOss(host,formData){
        return new Promise((resolve, reject) => {
          axios.post(host, formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
            console.log('ali oss res 上传结果:',res)
            resolve(res.data.filename) // 假设服务器返回的图片 URL 是 response.data.url
          }).catch(error => {
            reject(error)
          })
        })
      },
      get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      Ymdhis(){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return ''+year+month+day+hour+minute+second+(Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000);
      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      chooseItem(){

      }
    },
    // 监听
    watch: {
      visible(val) {
        if (val) {
          this.form.id=this.formData.item.id;
          this.form.lgs_shop_id=this.formData.item.lgs_shop_id;
          this.form.lgsshop_name=this.formData.item.lgsshop.name;
          this.getShopInvoiceDefaultOne();
          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }

        }
      },
    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }

  .inner-dialog /deep/ .el-dialog {
    z-index: 9999; /* 确保这个值高于外层 el-dialog 的 z-index */
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .custom-image img{width: 80px;height: 80px;}
 /deep/ .el-dialog__body{padding-top:0 !important;}
</style>
